export default {
  // HoS
  HOS_DRIVERS: "HosDrivers",
  HOS_LOGS: "Driveractivity",
  HOS_EVENTS: "Event",
  HOS_EVENTS_MASTER: "Masterevent",
  HOS_EVENTS_VIEW: "Eventview",
  HOS_DRIVER_LOGS: "Driverlogs",
  HOS_VIOLATIONS: "Violation",
  HOS_RECENT_VIOLATIONS: "Recentviolation",
  HOS_DRIVER_VIOLATIONS: "Driverviolation",
  HOS_DRIVER_VIOLATION_DOCUMENTS: "Violationdocument",
  HOS_UNIDENTIFIED_DRIVING: "Unidentifiedevents",
  HOS_ELD_DISCONNECTIONS: "Elddisconnection",
  HOS_ELD_MALFUNCTIONS: "Eldmalfunctions",
  HOS_FMCSA_DATA_TRANSFER: "Fmcsainspection",

  // Safety
  SAFETY_ALERTS: "Safetyalerts",

  // Locations
  LOCATIONS_LIVETRACK_TOKENS: "Livetracktoken",
  LOCATIONS_HISTORY_VEHICLES: "Locationhistoryvehicles",
  LOCATIONS_STATE_TRIPS: "Tripsview",
  LOCATIONS_STATE_TRIPS_BY_VEHICLE: "Tripsviewbyvehicle",
  LOCATIONS_STATE_TRIPS_BY_STATE: "Tripsviewbystate",

  // Assets
  ASSETS_DVIR_HISTORY: "Dvirhistory",
  ASSETS_DVIR_VEHICLE_HISTORY: "Dvirvehiclehistory",
  ASSETS_DVIR_VEHICLE_DEFECTS: "Dvirvehicledefects",
  ASSETS_MAINTENANCE: "Vehiclemaintenancesummary",
  ASSETS_VEHICLE_MAINTENANCE: "Vehiclemaintenance",
  ASSETS_MALFUNCTIONS_DIAG: "Diagnostics",

  // Administration
  ADMIN_COMPANIES: "Company",
  ADMIN_VEHICLES: "Vehicle",
  ADMIN_VEHICLES_VIEW: "Vehicleview",
  ADMIN_DRIVERS: "Driver",
  ADMIN_DRIVERS_VIEW: "Driverview",
  ADMIN_FLEET_MANAGERS: "Fleetmanager",
  ADMIN_TRAILERS: "Trailer",
  ADMIN_TRAILER_GPS_PROVIDERS: "Trailertrackingprovider",
  ADMIN_FUEL_PROVIDERS: "Fuelprovider",
  ADMIN_GROUPS: "Group",
  ADMIN_ROLES: "Role",
  ADMIN_ELDS: "Elddevice",
  ADMIN_NOTIFICATIONS: "Notificationsubscription",
  ADMIN_DVIR_FORMS: "Dvirform",
  ADMIN_API_CLIENTS: "Publicapiclient",
  ADMIN_MOBILE_APP_VERSIONS: "Mobileappversion",

  // Master
  MASTER_TENANTS: "Tenant",
  MASTER_TENANTS_VIEW: "Tenantview",
  MASTER_ELDS: "Masterelddevice",
  MASTER_TENANT_ELDS_USAGE: "Masterelddeviceusage",
  MASTER_TENANT_ELDS: "Tenantelddeviceview",
  MASTER_TENANT_OWN_ELDS: "Customerselddevices",
  MASTER_TENANT_REGISTRATIONS: "Tenantregistration",
  MASTER_FLEET_MANAGERS: "Masterfleetmanager",
  ADMIN_ELD_MESSAGES: "Elddevicemessage",
  MASTER_DEMO_ACCOUNTS: "Demoaccount",
  MASTER_VIRTUAL_TENANTS: "Virtualtenant",
};
